export const FETCHING_LOGIN_REQUEST = '[LOGIN] LOGIN_REQUEST';
export const FETCHING_LOGIN_SUCCESS = '[LOGIN] LOGIN_SUCCESS';
export const FETCHING_LOGIN_FAILURE = '[LOGIN] LOGIN_FAILURE';
export const FETCHING_LOGOUT_REQUEST = '[LOGOUT] LOGOUT_REQUEST';
export const FETCHING_LOGOUT_SUCCESS = '[LOGOUT] LOGOUT_SUCCESS';
export const FETCHING_LOGOUT_FAILURE = '[LOGOUT] LOGOUT_FAILURE';
export const SET_LOGIN_FORM_CHANGE = '[LOGIN] LOGIN_FORM_CHANGE';
export const SET_LOGIN_FIELD_ERROR = '[LOGIN] LOGIN_FIELD_ERROR';
